import React from 'react';

import styles from './styles.css';

const Chart = ({ title, value }) => (
  <div className={styles.chart}>
    <span className={styles.bar}>
      <span className={styles.value} style={{ height: value + '%' }} />
    </span>
    <p className={styles.title}>{title}</p>
  </div>
);

const BarChart = ({ copy, data }) => (
  <div className={styles.container}>
    <div className={styles.grid}>
      <div className={styles.chartContainer}>
        {data.map(dataItem => {
          const { title, value } = dataItem;
          return (
            <Chart key={`${title}_${value}`} title={title} value={value} />
          );
        })}
      </div>
      <p className={styles.copy}>{copy}</p>
    </div>
  </div>
);

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/BarChart/index.js